import styled from "styled-components";

export const SLayout = styled.div`
    background: ${({ theme }) => theme.colors.bg2};
    width: 100%;
    overflow-x: hidden;
    min-height: 100vh;
    
    /* Desktop layout - horizontal flex row with sidebar and main content */
    @media (min-width: 769px) {
        display: flex;
        flex-direction: row;
        height: 100vh;
        height: 100dvh;
    }
    
    /* Mobile layout - vertical flex, let content determine height */
    @media (max-width: 768px) {
        display: flex;
        flex-direction: column;
        /* Remove fixed height constraints - let content flow naturally */
        min-height: 100vh;
        height: auto;
    }
`;

export const SMain = styled.main`
    background: ${({ theme }) => theme.colors.bg2};
    overflow-x: hidden;

    /* Desktop layout - flex item that takes remaining space */
    @media (min-width: 769px) {
        flex: 1;
        height: 100vh;
        overflow-y: auto;
        margin-left: var(--sidebar-collapsed-width);
        transition: margin-left 0.3s ease;
    }

    /* Mobile layout - no overflow control, let body handle scrolling */
    @media (max-width: 768px) {
        flex: 1;
        overflow-y: visible;
        padding-bottom: ${({ $hideBottomNavigation }) => 
          $hideBottomNavigation ? '0' : 'var(--bottom-nav-height)'};
        min-height: auto;
        height: auto;
        margin-left: 0;
    }
`;